"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionsAdapter = void 0;
const tslib_1 = require("tslib");
const promotionsAdapterInterface_1 = require("./promotionsAdapterInterface");
const promoClient_1 = require("../clients/promoClient");
const axiosHttpClient_1 = require("../http/axiosHttpClient");
const promotionBuilder_1 = require("../builders/promotionBuilder");
const promotionValidator_1 = require("../validators/promotionValidator");
class PromotionsAdapter {
    constructor(promoClient, promotionBuilder, promotionValidator) {
        this.promoClient = promoClient;
        this.promotionBuilder = promotionBuilder;
        this.promotionValidator = promotionValidator;
        this.cache = {
            brand: undefined,
            apiPromotions: []
        };
        this.promoClient = promoClient;
        this.promotionBuilder = promotionBuilder;
        this.promotionValidator = promotionValidator;
    }
    suggest(sq, brand, catalogs, code) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const promotions = [];
            const apiPromotionsUnsorted = [];
            let apiPromotions = [];
            // Use cached apiPromotions if brand matches otherwise get all valid promotions available for a specific brand
            apiPromotions = yield this.getApiPromotions(brand);
            // Filter promotions based on promo code and validate
            if (code) {
                const filteredPromos = apiPromotions.filter(promotion => promotion.pattern[0].name === code);
                for (const promotion of filteredPromos) {
                    if (!this.promotionValidator.validateDateTime(promotion.validFor.startDateTime, promotion.validFor.endDateTime)) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.carrier, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'carrier as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.development, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'development as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.suburb, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'suburb as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.state, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'state as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.technology, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'technology as condition'))) {
                        continue;
                    }
                    // If a promotion is ATL it has a criteriaGroup 'display as condition'
                    if (!promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'display as condition')) {
                        continue;
                    }
                    promotions.push(this.promotionBuilder.build(promotion, catalogs));
                }
            }
            else {
                // Loop through promotions to see which are valid
                for (const promotion of apiPromotions) {
                    if (!this.promotionValidator.validateDateTime(promotion.validFor.startDateTime, promotion.validFor.endDateTime)) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.carrier, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'carrier as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.development, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'development as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.suburb, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'suburb as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.state, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'state as condition'))) {
                        continue;
                    }
                    if (!this.promotionValidator.validateCriteriaGroup(sq.technology, promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'technology as condition'))) {
                        continue;
                    }
                    // If a promotion is ATL it has a criteriaGroup 'display as condition'
                    if (!promotion.pattern[0].criteriaGroup.find(c => c.groupName === 'display as condition')) {
                        continue;
                    }
                    apiPromotionsUnsorted.push(promotion);
                }
            }
            // Sort promos based on the number of criteria groups validated
            const apiPromotionsSorted = apiPromotionsUnsorted.sort((a, b) => {
                return b.pattern[0].criteriaGroup.length - a.pattern[0].criteriaGroup.length;
            });
            // Promos that are valid are formatted and added to the promotions[]
            for (const apiPromotion of apiPromotionsSorted) {
                promotions.push(this.promotionBuilder.build(apiPromotion, catalogs));
            }
            return promotions;
        });
    }
    validate(sq, products, brand, code, catalogs, serviceDetails) {
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const promotions = [];
            let apiPromotions = [];
            // Use cached apiPromotions if brand matches otherwise get all valid promotions available for a specific brand
            apiPromotions = yield this.getApiPromotions(brand);
            // Filter promotions based on promo code and validate
            const filteredPromos = apiPromotions.filter(promotion => promotion.pattern[0].name === code);
            // Find the correct products to validate
            const internetProduct = products.find(product => product.type === 'internet');
            const contractLengthProduct = products.find(product => product.code === 'ACTIVATION-FEE');
            if (internetProduct && contractLengthProduct) {
                // Where values are null coalesce to 0 as this will invalidate that criteria
                const download = (_a = internetProduct.download) !== null && _a !== void 0 ? _a : 0;
                const contractLength = (_b = contractLengthProduct.term) !== null && _b !== void 0 ? _b : 0;
                const plan = (_c = internetProduct.symbillId) !== null && _c !== void 0 ? _c : 0;
                if (filteredPromos.length > 0 && internetProduct) {
                    for (const currentPromo of filteredPromos) {
                        // Each promotion criteria group is checked against the products in the cart and the sq
                        if (!this.promotionValidator.validateDateTime(currentPromo.validFor.startDateTime, currentPromo.validFor.endDateTime)) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(sq.carrier, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'carrier as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(sq.development, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'development as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(sq.suburb, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'suburb as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(download, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'plan speed as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(contractLength, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'contract length as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(plan, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'plan as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(download, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'speeds as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(sq.state, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'state as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(sq.technology, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'technology as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(serviceDetails.rtcDays, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'rtc_days as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(serviceDetails.newService, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'new service as condition'))) {
                            continue;
                        }
                        if (!this.promotionValidator.validateCriteriaGroup(serviceDetails.relocation, currentPromo.pattern[0].criteriaGroup.find(c => c.groupName === 'relocation as condition'))) {
                            continue;
                        }
                        // Only add a promotion that has passed all validation
                        promotions.push(this.promotionBuilder.build(currentPromo, catalogs));
                    }
                }
            }
            return promotions;
        });
    }
    getApiPromotions(brand) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let apiPromotions = [];
            // Use cached apiPromotions if brand matches otherwise get all valid promotions available for a specific brand
            if (this.cache.brand !== brand || this.cache.apiPromotions.length < 1) {
                apiPromotions = yield this.promoClient.getPromos(brand);
                this.cache = { brand: brand, apiPromotions: apiPromotions };
            }
            else {
                apiPromotions = this.cache.apiPromotions;
            }
            return apiPromotions;
        });
    }
    isPlanValid(products, code, brand) {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let apiPromotions = [];
            // Use cached apiPromotions if brand matches otherwise get all valid promotions available for a specific brand
            apiPromotions = yield this.getApiPromotions(brand);
            // Filter promotions based on promo code and validate
            const filteredPromos = apiPromotions.filter(promotion => promotion.pattern[0].name === code);
            if (filteredPromos.length === 0)
                return false;
            const promoToValidate = filteredPromos[0];
            // Find the correct products to validate
            const internetProduct = products.find(product => product.type === 'internet');
            if (internetProduct) {
                const download = (_a = internetProduct.download) !== null && _a !== void 0 ? _a : 0;
                const plan = (_b = internetProduct.symbillId) !== null && _b !== void 0 ? _b : 0;
                if (!this.promotionValidator.validateCriteriaGroup(download, promoToValidate.pattern[0].criteriaGroup.find(c => c.groupName === 'plan speed as condition'))) {
                    return false;
                }
                if (!this.promotionValidator.validateCriteriaGroup(plan, promoToValidate.pattern[0].criteriaGroup.find(c => c.groupName === 'plan as condition'))) {
                    return false;
                }
                if (!this.promotionValidator.validateCriteriaGroup(download, promoToValidate.pattern[0].criteriaGroup.find(c => c.groupName === 'speeds as condition'))) {
                    return false;
                }
                return true;
            }
            return false;
        });
    }
    isContractLengthValid(products, code, brand) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let apiPromotions = [];
            // Use cached apiPromotions if brand matches otherwise get all valid promotions available for a specific brand
            apiPromotions = yield this.getApiPromotions(brand);
            // Filter promotions based on promo code and validate
            const filteredPromos = apiPromotions.filter(promotion => promotion.pattern[0].name === code);
            if (filteredPromos.length === 0)
                return false;
            const promoToValidate = filteredPromos[0];
            // Find the correct products to validate
            const contractLengthProduct = products.find(product => product.code === 'ACTIVATION-FEE');
            if (contractLengthProduct) {
                const contractLength = (_a = contractLengthProduct.term) !== null && _a !== void 0 ? _a : 0;
                if (this.promotionValidator.validateCriteriaGroup(contractLength, promoToValidate.pattern[0].criteriaGroup.find(c => c.groupName === 'contract length as condition'))) {
                    return true;
                }
            }
            return false;
        });
    }
    static create(baseUrl) {
        if (!baseUrl.length) {
            throw new promotionsAdapterInterface_1.ValidationError('The base url must be supplied.');
        }
        if (baseUrl.charAt(baseUrl.length - 1) === '/') {
            throw new promotionsAdapterInterface_1.ValidationError('The supplied base URL cannot end in a slash.');
        }
        return new PromotionsAdapter(new promoClient_1.PromoClient(new axiosHttpClient_1.AxiosHttpClient(baseUrl)), new promotionBuilder_1.PromotionBuilder(), new promotionValidator_1.PromotionValidator());
    }
}
exports.PromotionsAdapter = PromotionsAdapter;
//# sourceMappingURL=promotionsAdapter.js.map